import { u as l, m as f, aq as p, o as m, b as d, c as n, e as k, f as C, l as h, w as _, i as S, k as v } from "./define-element-XpjsV6s1.js";
import { u as y } from "./use-cart-D8NOb7eE.js";
import { B as w } from "./Button-D5lKR5Sd.js";
const B = {
  ref: "container",
  class: "offset-continue-to-checkout"
}, T = {
  __name: "ContinueToCheckout",
  props: {
    inheritStyle: {
      type: String,
      default: "all"
    },
    // Left unset by default so the type-aware getCheckoutUrl() fallback
    // applies — pass an explicit checkout-url attribute to override it.
    checkoutUrl: {
      type: String,
      default: ""
    }
  },
  setup(a) {
    const e = a, { cart: r, loadCart: s } = y(), c = l("container"), u = f(() => e.checkoutUrl || p());
    function i(o) {
      window.location = o;
    }
    return m(() => {
      d(c.value, e.inheritStyle), s();
    }), (o, t) => (n(), k("div", B, [
      C(r).items.length ? (n(), h(w, {
        key: 0,
        onClick: t[0] || (t[0] = (U) => i(u.value))
      }, {
        default: _(() => t[1] || (t[1] = [
          S("Continue to Checkout", -1)
        ])),
        _: 1,
        __: [1]
      })) : v("", !0)
    ], 512));
  }
};
export {
  T as _
};
